import React from "react";
import PropTypes from "prop-types";
import { EventsProvider } from "./EventsProvider";
import EventsHeader from "./EventsHeader";
import EventsGrid from "./EventsGrid";
import Calendar from "./Calendar";
import Cards from "./Cards/Cards";
import { useMediaQuery } from "react-responsive";
import styled from "@emotion/styled";

import { Sizes } from "../../styles";

const Events = ({indexPage, lang}) => {

	const isDesktopOrLaptop = useMediaQuery({
		query: `(min-width: ${Sizes.screens.large})`,
	});

	const renderCalendar = () => {
		if (isDesktopOrLaptop) {
			return <Calendar />;
		}
		
		return null;
	}

	return (
		<EventsProvider 
			indexPage={indexPage}
			language={lang}
		>
			<EventsGrid>
				{ renderCalendar() }
				<MainContent>
					<EventsHeader />
					<Cards />
				</MainContent>
			</EventsGrid>
		</EventsProvider>
	);
}

Events.propTypes = {
	indexPage: PropTypes.string,
	lang: PropTypes.string,
};

export default Events;

const MainContent = styled.div`
`;